import { forwardRef } from 'react';
import { providerIdentity } from '@/lib/providers';
import type { WithClassName } from './types';

export type ProviderBadgeProps = WithClassName & {
  provider: string | null;
  connectionName?: string;
  size?: 'sm' | 'md';
};

export const ProviderBadge = forwardRef<HTMLSpanElement, ProviderBadgeProps>(function ProviderBadge(
  { provider, connectionName, size = 'md', className }, ref,
) {
  const identity = providerIdentity(provider);
  return <span ref={ref} className={`ui-provider ui-provider--${size} ${className ?? ''}`}>
    <span className="ui-provider__monogram" aria-hidden="true">{identity?.monogram ?? '?'}</span>
    <span>{identity?.label ?? 'Unknown provider'}{connectionName ? ` · ${connectionName}` : ''}</span>
  </span>;
});
